export const InterceptorHeaders = {
  ACCEPT_LANGUAGE: 'Accept-Language',
  X_CORRELATION_ID: 'X-Correlation-ID',
  X_TRACE_ID: 'X-Trace-ID',
  X_CLIENT_LAT: 'X-Client-Lat',
  X_CLIENT_LNG: 'X-Client-Lng',
} as const;
